import { observable, action, runInAction, computed } from 'mobx'
import { message } from 'antd'
import { json, get } from '../../../../utils/ajax'

class ToolModelStore {

    @observable list
    @observable pagination
    @observable loading
    @observable modal
    @observable forms

    constructor () {
        this.list = []
        this.pagination = {}
        this.loading = false
        this.modal = 'hide'
        this.forms = {}
    }

    /**
     * 初始化页面
     */
    @action
    initListPage = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        if (page) {
            page--
        } else if (this.pagination.page) {
            page = this.pagination.page - 1
        } else {
            page = 0
        }
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/toolManual/model/list`,{
            page: page,
            size: 10
        })
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.list = res.content
            this.pagination = {
                results: res.size,
                page: res.number + 1,
                total: res.totalElements
            }
            this.loading = false
        })
    }

    /**
     * 平行化表单，传值给form
     */
    @computed
    get fields() {
        let fields = {
            id: {value: this.forms.id},
            name: {value: this.forms.name},
        }
        return fields
    }
    /**
     * 将表单时对象化，绑值给store。form
     */
    @action
    onEditFieldChange = (changedFields) => {
        const fields = {...this.fields, ...changedFields}
        let forms = {
            id: fields.id.value,
            name: fields.name.value,
        }
        this.forms = forms
    }

    /**
     * 显示模式
     */
    @action showModal = (flag) => {
        runInAction(() => {
            this.loading = true
            this.modal = flag ? 'show' : 'hide'
            this.loading = false
        })
    }

    /**
     * 新增车型 + 修改车型
     */
    @action saveModel = async () => {
        runInAction(() => {
            this.loading = true
        })
        if (!this.forms.id) {
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/toolManual/model/add`, {
                ...this.forms
            })
            runInAction(() => {
                this.modal = 'hide'
                message.success('保存车型成功')
                this.loading = false
            })
            this.initListPage(this.page)
        }else {
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/toolManual/model/update`, {
                ...this.forms
            })
            runInAction(() => {
                this.modal = 'hide'
                message.success('修改车型成功')
                this.loading = false
            })
            this.initListPage(this.page)
        }
    }

    /**
     * 初始化表单，可以不传参数，初始化全部为 null
     * @param id 根据id查询
     */
    @action initEdit = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/toolManual/model/id/${id}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.forms = res
            this.loading = false
            this.modal = 'show'
        })
    }

    /**
     * 清空forms
     */
    @action empetyForms = () => {
        runInAction(() => {
            this.forms = {}
        })
    }

    /**
     * 删除
     */
    @action
    deleteModelId = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.batchDelete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/toolManual/model/${id}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.loading = false
        })
        if(this.list.length === 1){
            await this.initListPage(this.pagination.page -1)
        }else{
            await this.initListPage(this.pagination.page)
        }
    }
}
export default new ToolModelStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/ToolManual/ToolModel/store.js